module.exports = __webpack_public_path__ + "img/advantage3Green.4b61cd72.png";